<template>
  <div
    class="flex flex-col items-center justify-center cursor-pointer border-2 h-[26px] w-[26px] mr-2"
    :class="StateBackground + ' ' + size"
    @click="focus()"
  >
    <svg
      class="fill-white w-[11px]"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 51.7 40.87"
    >
      <path
        d="m47.14,13.3c-1.23,0-2.23,1.05-2.23,2.35s1,2.35,2.23,2.35,2.24-1.05,2.24-2.35-1-2.35-2.24-2.35Z"
      />
      <path
        d="m42.69,1.96v-.33c0-.9-.73-1.63-1.63-1.63h-12.16c-.9,0-1.63.73-1.63,1.63v.15H11.04C4.94,1.78,0,6.72,0,12.82v22.44c0,3.1,2.51,5.61,5.61,5.61h7.92v-3.89c0-.85.69-1.54,1.54-1.54h13.82s7.72-.01,7.72-.01c.85,0,1.54.69,1.54,1.54v3.89h8.02c3.05,0,5.53-2.47,5.53-5.53V12.83c0-5.41-3.88-9.9-9.01-10.87Zm-14.31-.23c0-.54.44-.97.97-.97h11.25c.54,0,.97.44.97.97v1.31c0,.54-.44.97-.97.97h-11.25c-.54,0-.97-.44-.97-.97v-1.31ZM5.08,37.78c-1.3,0-2.35-1.05-2.35-2.35s1.05-2.35,2.35-2.35,2.35,1.05,2.35,2.35-1.05,2.35-2.35,2.35Zm-.07-9.04h1.77c.36,0,.65.29.65.65v.59c0,.36-.29.65-.65.65h-1.77c-.36,0-.65-.29-.65-.65v-.59c0-.36.29-.65.65-.65Zm-.65-1.35v-.59c0-.36.29-.65.65-.65h1.77c.36,0,.65.29.65.65v.59c0,.36-.29.65-.65.65h-1.77c-.36,0-.65-.29-.65-.65Zm.28-7.46c-2.03,0-3.68-1.65-3.68-3.68s1.65-3.68,3.68-3.68,3.68,1.65,3.68,3.68-1.65,3.68-3.68,3.68Zm24.25,14.23H11.32v-.02c-.89,0-1.62-.73-1.62-1.63V10.12c0-.9.73-1.63,1.63-1.63h29.06c.9,0,1.63.73,1.63,1.63v22.41c0,.9-.73,1.63-1.63,1.63h-11.5Zm12.28,4.32c-.84,0-1.53-.68-1.53-1.53s.68-1.53,1.53-1.53,1.53.68,1.53,1.53-.68,1.53-1.53,1.53Zm5.59-10.75c0,.36-.29.65-.65.65h-1.77c-.36,0-.65-.29-.65-.65v-.59c0-.36.29-.65.65-.65h1.77c.36,0,.65.29.65.65v.59Zm0-2.59c0,.36-.29.65-.65.65h-1.77c-.36,0-.65-.29-.65-.65v-.59c0-.36.29-.65.65-.65h1.77c.36,0,.65.29.65.65v.59Zm.39-5.82c-2.03,0-3.68-1.65-3.68-3.68s1.65-3.68,3.68-3.68,3.68,1.65,3.68,3.68-1.65,3.68-3.68,3.68Z"
      />
      <path
        d="m36.37,36.36H15.26c-.51,0-.92.41-.92.92v3.58s.01.01.01.01h22.92v-.82s.02-.06.02-.1v-2.67c0-.51-.41-.92-.92-.92Z"
      />
      <path
        d="m4.63,13.91c-1.3,0-2.35,1.05-2.35,2.35s1.05,2.35,2.35,2.35,2.35-1.05,2.35-2.35-1.05-2.35-2.35-2.35Z"
      />
    </svg>
  </div>
</template>

<script>
import { rcPlusStateColor } from "@/utils/Utils.js";

export default {
  props: {
    config: Object,
    size: String,
  },
  computed: {
    StateBackground() {
      let LastPing =
        this.config?.rcPlus?.status?.LastPing != null
          ? parseInt(this.config.rcPlus.status.LastPing)
          : 99999999;

      return "border-" + rcPlusStateColor(LastPing);
    },
  },
  methods: {
    focus() {
      this.config.rcPlus.methods.ShowTheRcPlus();
    },
  },
};
</script>
